<template>
  <div class="legal">
    <div class="container">
      <h1>Legal Information</h1>
          <p>
            Studentenfutter UG (haftungsbeschränkt)<br>
            Rudolfstraße 3<br>
            76131 Karlsruhe<br>
            Tel.: +49 176 68054542<br>
            Registergerich: Amtsgericht Mannheim<br>
            Registernummer: HRB 730915<br>
            Ust.-Id. gem. §27 a Umsatzsteuergesetz:<br>DE815775950
        </p>
        <p>
          Responsible according to § 55 Abs. 2 RStV: Giorgio Groß<br>
          Contact:<br>
          init.giorgio@gmail.com<br>
          For contents on other pages that are linked to and for contents that are imported from other pages the website operators of those sites are responsible, respectively.<br>
        </p>
        <p>
          Copyright Giorgio Groß, 2020, all rights reserved.
          The copyright for the imported data is owned by the data creators; the sources of imported data are shown on the imported content.
          The website operator of this page does not own the copyright for the imported data, but references data from other sources and provides a reference to the source, wherever applicable.
          Imported data and work of other people is never monetized, though the service of importing these data and storing that data for personal use of the website user may be monetized later.
          If there is something wrong with this site or with the content on this website or if you feel that there is a copyright infringement message the website owner (above) before sending a formal warning.
          Disclaimer: This website is proviede as is and without warranties of any kind.
        </p>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'legal',
  components: {
  }
}
</script>
